import PrimaryBadge from "components/Global/Badge/PrimaryBadge";
import PropTypes from "prop-types";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, Grid, TableCell } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import { InviteToItemsModal } from "../Modals/InviteToItemsModal";

const StyledButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const StandardCaseStyledButton = styled(StyledButton)`
  && {
    text-transform: none;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
`;

const ItemCountBadge = styled(PrimaryBadge)`
  && {
    span {
      height: 22px;
      width: 22px;
    }
  }
`;

const HeaderLeftContainer = styled(Grid)`
  max-width:calc(100% - 250px) !important;
`;

const AssignedItemsGrid = styled(Grid)`
  && {
    margin-top: 25px;
    margin-bottom: 10px;
  }
`;

const AssignedItemsHeaderTitle = styled(Grid)`
  && {
    margin-right: 30px;
    font-size: 18px;
  }
`;

export class AssignedItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteToItemsModal: false,
      showAssignedItemTable: false
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      availableItems: props.availableItems,
      assignedItems: props.assignedItems
    };
  }

  assignedItemsTableColumns = [
    {
      id: "itemName",
      label: "Name",
      isString: true,
      isBaseColumn: true,
      dataField: "name",
      width: 450
    },
    {
      id: "invitedBy",
      label: "Invited By",
      isString: true,
      cellValueCalculator: item => `${this.props.getInvitedByContact(item).firstName} ${this.props.getInvitedByContact(item).lastName}`
    },
    {
      id: "actions",
      actions: true,
      blankLabel: true,
      cell: ({ data }) => (
        <TableCell>
          <StyledButton
            onClick={() => this.setState({ itemToRemove: data, isRemoveItemModalOpen: true })}
          >
            <DeleteIcon className="icon delete" />
          </StyledButton>
        </TableCell>
      )
    }
  ];

  render() {
    return (
      <AssignedItemsGrid>
        {this.props.assignedToAllItems && (
          <Grid container item alignItems="center">
            <b>{this.props.hasAllItemsMessage} <StandardCaseStyledButton onClick={this.props.onRemoveFromAllItems}>{this.props.removeAllItemsMessage}</StandardCaseStyledButton></b>
          </Grid>
        )}
        {!this.props.assignedToAllItems && (
          <Fragment>
            <InviteToItemsModal
              items={this.props.availableItems}
              itemName={this.props.itemName}
              isOpen={this.state.showInviteToItemsModal}
              onClose={() => this.setState({ showInviteToItemsModal: false })}
              onAddItems={items => this.props.onAddItems(items)}
              onAddToAllItems={this.props.onAddToAllItems}
              addToAllItemsLabel={this.props.addToAllItemsLabel}
            />
            <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={16}>
              <HeaderLeftContainer item xs={8}>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                  <AssignedItemsHeaderTitle item>
                    Assigned {this.props.itemName}s
                  </AssignedItemsHeaderTitle>
                  <Grid item>
                    <ItemCountBadge badgeContent={this.props.assignedItems.length} />
                  </Grid>
                  <Grid item style={{ marginLeft: 10 }}>
                    <Button style={{ color: "#999999" }} onClick={() => this.setState({ showAssignedItemTable: !this.state.showAssignedItemTable })}>{this.state.showAssignedItemTable ? "HIDE" : "SHOW"}</Button>
                  </Grid>
                </Grid>
              </HeaderLeftContainer>
              <Grid item xs={4} style={{ textAlign: "right" }}>
                <StyledButton onClick={() => this.setState({ showInviteToItemsModal: true })}>Invite to {this.props.itemName}s</StyledButton>
              </Grid>
            </Grid>
            {this.state.showAssignedItemTable && (
              <EnhancedTable
                columnDefinitions={this.assignedItemsTableColumns}
                rows={this.props.assignedItems}
                noRowsMessage={`There are no ${this.props.longItemName}s assigned`}
                sortable
                orderBy={this.assignedItemsTableColumns[0]}
                shouldHideConfig
                shouldHideExport
                maxHeight={450}
              />
            )}
          </Fragment>
        )}
        <SimpleConfirmDialog
          title="Confirm Delete"
          message={this.state.itemToRemove && (
            <div>
              You are about to remove access for {this.props.guestContact.firstName} {this.props.guestContact.lastName} to <b>{this.state.itemToRemove.name}</b> {this.props.itemName.toLowerCase()}.  Are you sure you want to do this?
            </div>
            )
          }
          noText="NO"
          yesText="YES, DELETE"
          modalOpen={this.state.isRemoveItemModalOpen}
          handleNo={() => this.setState({ isRemoveItemModalOpen: false })}
          handleYes={() => {
            const newAssignedItems = this.props.assignedItems;
            _.remove(newAssignedItems, this.state.itemToRemove);
            this.props.onRemoveItems([this.state.itemToRemove.id]);
            this.setState({ isRemoveItemModalOpen: false });
          }}
        />
      </AssignedItemsGrid>
    );
  }
}

AssignedItems.propTypes = {
  guestContact: PropTypes.object.isRequired,
  assignedItems: PropTypes.object.isRequired,
  assignedToAllItems: PropTypes.bool.isRequired,
  availableItems: PropTypes.object.isRequired,
  itemName: PropTypes.string.isRequired,
  longItemName: PropTypes.string.isRequired,
  addToAllItemsLabel: PropTypes.string.isRequired,
  onAddItems: PropTypes.func.isRequired,
  onAddToAllItems: PropTypes.func.isRequired,
  onRemoveFromAllItems: PropTypes.func.isRequired,
  onRemoveItems: PropTypes.func.isRequired,
  getInvitedByContact: PropTypes.func.isRequired
};

export default compose(connect())(AssignedItems);
